var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("header-container " + (_vm.alignBarStart ? 'alignBarStart' : ''))},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"gray-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }